import { COLORS, PROP_DEFINITIONS } from "./dioramaLayout";
import { InteractiveProp } from "./InteractiveProp";

const DEF = PROP_DEFINITIONS.find((p) => p.id === "fileCabinet")!;

/** Visual-only file cabinet — reusable outside the engine's InteractiveProp wrapper. */
export function FileCabinetModel() {
  return (
    <group>
      {/* Cabinet body */}
      <mesh position={[0, 1.0, 0]} castShadow>
        <boxGeometry args={[1.0, 2.0, 0.7]} />
        <meshStandardMaterial color={COLORS.teal} flatShading />
      </mesh>

      {/* Drawers */}
      {[0, 1, 2].map((i) => (
        <group key={i}>
          <mesh position={[0, 0.35 + i * 0.6, 0.38]}>
            <boxGeometry args={[0.9, 0.5, 0.05]} />
            <meshStandardMaterial color={COLORS.tealDark} flatShading />
          </mesh>
          <mesh position={[0, 0.35 + i * 0.6, 0.42]}>
            <boxGeometry args={[0.25, 0.06, 0.06]} />
            <meshStandardMaterial color={COLORS.orange} flatShading />
          </mesh>
        </group>
      ))}

      {/* Label on top drawer */}
      <mesh position={[0, 0.5, 0.42]}>
        <boxGeometry args={[0.3, 0.15, 0.01]} />
        <meshStandardMaterial color={COLORS.cream} flatShading />
      </mesh>
    </group>
  );
}

export function OfficeFileCabinet() {
  return (
    <InteractiveProp
      propId={DEF.id}
      label={DEF.label}
      clickMessage={DEF.clickMessage}
      position={DEF.position}
    >
      <FileCabinetModel />
    </InteractiveProp>
  );
}
